import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';

export const adminGuard: CanActivateFn = () => {
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  if (adminAuth.isAdminLoggedIn()) {
    return true;
  }

  return router.createUrlTree(['/admin/login']);
};

/** Admin login page: redirect to dashboard when already authenticated as admin. */
export const adminGuestGuard: CanActivateFn = () => {
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  if (adminAuth.isAdminLoggedIn()) {
    return router.createUrlTree(['/admin/dashboard']);
  }

  return true;
};
